import { motion } from "framer-motion";
import type { MotionProps, Transition } from "framer-motion";
import type { ReactNode } from "react";
import { EASE_CALM } from "../../lib/motion";

type TCalmRevealProps = {
	visible: boolean;
	playing: boolean;
	children: ReactNode;
	className?: string;
	hidden?: MotionProps["animate"];
	shown?: MotionProps["animate"];
	duration?: number;
	delay?: number;
	ease?: Transition["ease"];
	as?: "div" | "span" | "p" | "h2";
};

export function CalmReveal({
	visible,
	playing,
	children,
	className,
	hidden = { opacity: 0, y: 28, scale: 0.96 },
	shown = { opacity: 1, y: 0, scale: 1 },
	duration = 0.65,
	delay = 0,
	ease = EASE_CALM,
	as = "div",
}: TCalmRevealProps) {
	const MotionTag = motion[as];

	return (
		<MotionTag
			className={className}
			initial={false}
			animate={visible ? shown : hidden}
			transition={playing ? { duration, delay, ease } : { duration: 0 }}
		>
			{children}
		</MotionTag>
	);
}
